import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/App";

export const SettingsModal = ({
  open, onOpenChange, passedUser, isPro, currentPlan,
  notionStatus, notionToken, setNotionToken, notionSyncing,
  onConnectNotion, onNotionSync, onDisconnectNotion,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="modal-dark sm:max-w-lg">
      <DialogHeader>
        <DialogTitle className="font-serif text-[#FDF8EE]">Settings</DialogTitle>
      </DialogHeader>
      <div className="py-4 space-y-6">
        {/* Notion Integration */}
        <div>
          <h3 className="font-mono text-[9px] text-[#4A3A1A] uppercase tracking-[1px] mb-3">Notion Integration</h3>
          {notionStatus.connected ? (
            <div className="space-y-3">
              <div className="flex items-center gap-3 p-3 bg-[rgba(122,184,160,0.06)] border border-[rgba(122,184,160,0.15)]">
                <span className="text-[#7AB8A0]">&#10003;</span>
                <div className="flex-1">
                  <p className="text-sm text-[#FDF8EE]">Connected to Notion</p>
                  <p className="font-mono text-[9px] text-[#4A3A1A]">{notionStatus.bot_name}</p>
                </div>
                <button onClick={onDisconnectNotion} className="font-mono text-[9px] text-red-400 hover:underline" data-testid="notion-disconnect-btn">Disconnect</button>
              </div>
              {notionStatus.database_id ? (
                <div className="flex items-center justify-between">
                  <span className="text-sm text-[#8C7A5A]">Ryan database ready</span>
                  <button onClick={onNotionSync} disabled={notionSyncing} className="btn-primary text-sm" data-testid="notion-sync-btn">{notionSyncing ? "Syncing..." : "Sync Now"}</button>
                </div>
              ) : (
                <p className="text-sm text-[#C8600A]">No database linked. Re-connect with a parent page.</p>
              )}
              {notionStatus.database_url && (
                <a href={notionStatus.database_url} target="_blank" rel="noopener noreferrer" className="font-mono text-[9px] text-[#E8A030] hover:underline uppercase tracking-[1px]">Open in Notion</a>
              )}
            </div>
          ) : (
            <div className="space-y-3">
              <p className="text-sm text-[#8C7A5A] leading-relaxed">Sync your bookmarks to Notion using your own integration token.</p>
              <div className="bg-[rgba(232,160,48,0.04)] border border-[rgba(232,160,48,0.1)] p-3 space-y-2">
                <p className="font-mono text-[9px] text-[#8C7A5A] uppercase tracking-[0.5px]">Setup in 3 steps:</p>
                <ol className="list-decimal list-inside space-y-1.5 text-[11px] text-[#8C7A5A] leading-relaxed">
                  <li>Go to <a href="https://www.notion.so/my-integrations" target="_blank" rel="noopener noreferrer" className="text-[#E8A030] hover:underline">notion.so/my-integrations</a></li>
                  <li>Create a new integration &amp; copy the token</li>
                  <li>Share a Notion page with your integration, then paste the token below</li>
                </ol>
              </div>
              <input type="password" value={notionToken} onChange={(e) => setNotionToken(e.target.value)} placeholder="ntn_xxxxxxxxxxxxx" className="input-dark w-full" data-testid="notion-token-input" />
              <button onClick={onConnectNotion} disabled={!notionToken.trim()} className="btn-primary w-full" data-testid="notion-connect-btn">Connect to Notion</button>
            </div>
          )}
        </div>

        {/* Account Info */}
        <div>
          <h3 className="font-mono text-[9px] text-[#4A3A1A] uppercase tracking-[1px] mb-3">Account</h3>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between text-[#8C7A5A]"><span>Email</span><span className="text-[#F5ECD0]">{passedUser?.email}</span></div>
            <div className="flex justify-between text-[#8C7A5A]"><span>Plan</span><span className="text-[#E8A030] font-medium">{isPro ? (currentPlan?.includes('synthesis') || currentPlan?.includes('enterprise') ? 'Synthesis' : 'Signal') : 'Free'}</span></div>
          </div>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
